<template>
  <div class="padding40" v-if="!isView" style="padding-bottom: 0">
    <slot name="before"/>
    <p class="import-file-text" v-if="excelExample">
      Вы можете импортировать {{isPassKindMaterial ? 'предъявителей':'посетителей'}}, загрузив файл. Для этого
      <a
        :href="excelExample.url"
        download
      >скачайте шаблон</a> (обновлен {{ excelExample.updated_at }}), заполните его и загрузите.
      <slot name="additional-text"/>
    </p>
    <label class="btn import-file-btn" for="file-import">Загрузить файл</label>
    <input type="file" style="display: none;" id="file-import" @change="importFileUpload"/>
    <div class="text-danger" v-if="fileImport.error">Неверный тип файла. Загрузите шаблон.</div>
    <message-alert
      :show="visibleAlert"
      :is-success="!fileImport.error"
      :message="fileImportMessage"
    />
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import { cloneObject } from '@/common/helpers'
import { ResponseStatuses } from '@/enums/ResponseStatuses'
import Visitor from '@/common/classes/Visitor';
import { PassKinds } from '@/common/enums/PassKinds';

export default {
  name: 'ImportFileFormBlock',
  mixins: [applicationInputMixin, applicationFormMixin, visitorsSectionMixin],

  props: {
    excelExample: {
      type: Object,
      default: null
    }
  },

  data: () => ({
    fileImport: {
      file: null,
      error: false,
      message: null,
      sendingFile: false
    },
    visibleAlert: false,
    error: null
  }),

  computed: {
    fileImportMessage () {
      return this.fileImport.message
        ? this.fileImport.message
        : 'Данные ' +
        (this.fileImport.error ? 'не' : 'успешно') +
        ' загружены.'
    }
  },

  methods: {
    async importFileUpload ($event) {
      this.fileImport.sendingFile = true

      const formData = new FormData()
      this.fileImport.file = $event.target.files[0]

      if (this.fileImport.file) {
        formData.append('action', 'file-import')
        formData.append('file', this.fileImport.file)

        await ApiClient.importVisitorsFromFile(formData).then((response) => {
          const responseData = response.data
          this.fileImport.sendingFile = false

          if (responseData.status !== ResponseStatuses.Success) {
            this.fileImport.error = true
            this.fileImport.message = responseData.message
          } else {
            this.fileImport.error = false
            this.fileImport.message = responseData.message
            const visitors = []

            for (const visitor of responseData.data) {
              if (visitor) {
                visitors.push(
                  Object.assign(
                    cloneObject(new Visitor()),
                    cloneObject(visitor)
                  )
                )
              }
            }

            this.$emit('fill-visitors', visitors)
            this.$emit('import-file', this.fileImport)
          }
        })

        this.visibleAlert = true
        setTimeout(() => {
          this.visibleAlert = false
        }, 5000)

        $event.target.value = null
      }
    }
  }
}
</script>
